export const VISIBLE_OFFSET = 8;
export const HIDDEN_OFFSET = 35;
export const AUTO_HIDE_DELAY = 3000;
export const CLICK_THRESHOLD = 10;